import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const openConnection = ({ id, token }) =>
  Manager.client(token).post(Endpoints.connection.openConnection, {
    eklok: id,
  });

const closeConnection = ({ id, token }) =>
  Manager.client(token).post(Endpoints.connection.closeConnection, {
    eklok: id,
  });

export const Request = {
  openConnection,
  closeConnection,
};
